import { render, staticRenderFns } from "./flipcard.vue?vue&type=template&id=17a4c5ef"
import script from "./flipcard.vue?vue&type=script&lang=js"
export * from "./flipcard.vue?vue&type=script&lang=js"
import style0 from "./flipcard.vue?vue&type=style&index=0&id=17a4c5ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports